export const FEATURE_NAME = '@zerops/zerops/feature/top-up-dialog/top-up-promo-code-form';
